<template>
  <div class="lalala tree-container" style="height:100%">
    <el-input
      placeholder="输入关键字进行过滤"
      v-model="filterText"
      class="search"
    >
    </el-input>
    <el-scrollbar style="height: calc(100% - 107px);margin-top: 8px;border: 1px solid #DCDFE6;border-radius: 4px;">
      <el-tree
        :data="treeData"
        node-key="id"
        default-expand-all
        @node-click="handleLeftclick"
        @node-drop="handleDrop"
        @node-contextmenu="rightClick"
        :filter-node-method="filterNode"
        draggable
        ref="tree"
        :props="defaultProps"
        :expand-on-click-node="false"
      >
        <span
          class="slot-t-node"
          slot-scope="{ node, data }"
          @dblclick="editNode(data)"
        >
          <span v-show="!(editId == data.id) || data.id == 0">
            <span :class="[data.id >= 99 ? 'slot-t-node--label' : '']">{{
              node.label
            }}</span>
          </span>
          <span v-show="editId == data.id && data.id != 0">
            <el-input
              class="slot-t-input"
              size="mini"
              autofocus
              v-model="data.name"
              :ref="'slotTreeInput' + data.id"
              @blur.stop="NodeBlur(node, data)"
              @keydown.enter.native="NodeBlur(node, data)"
            ></el-input>
          </span>
        </span>
      </el-tree>
    </el-scrollbar>
    <el-card :style="style" class="box-card" ref="card" v-show="menuVisible">
      <!-- <div @click="addSameLevelNode()" v-show="firstLevel">
        <i class="el-icon-circle-plus-outline"></i>&nbsp;&nbsp;同级增加
      </div> -->
      <div class="add" @click="addChildNode()">
        <i class="el-icon-circle-plus-outline"></i>&nbsp;&nbsp;子级增加
      </div>
      <div class="delete" @click="deleteNode()">
        <i class="el-icon-remove-outline"></i>&nbsp;&nbsp;删除节点
      </div>
      <div class="edit" @click="editNode()">
        <i class="el-icon-edit"></i>&nbsp;&nbsp;修改节点
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  GetDepartmentList,
  UpdateDepartment,
  AddDepartment,
  DeleDepartment,
} from "@/api/user.js";
import {UpdateDepartmentByMove} from '@/api/staff'
export default {
  name: "tree",
  props:{
    height:{
      type:Number
    }
  },
  data() {
    return {
      style: {
        left: 0,
        top: 0,
      },

      eleId: "",
      isShow: false,
      currentData: "",
      currentNode: "",
      menuVisible: false,
      firstLevel: false,
      filterText: "",
      maxexpandId: 4,
      treeData: [
        {
          id: 0,
          name: "所有部门",
          isEdit: false,
          children: [],
        },
      ],
      defaultProps: {
        children: "children",
        label: "name",
      },
      //当前编辑ID
      editId: -1,
    };
  },
  mounted() {
    this.getAllDepartment();
  },
  methods: {
    // 获取所有部门列表
    getAllDepartment() {
      GetDepartmentList().then((res) => {
        this.treeData[0].children = res.data.data;
      });
    },
    // 提交修改部门名称
    NodeBlur(Node, data) {
      if (data.name.length === 0) {
        if (data.id != -999) {
          this.$message.error("部门名不可为空！");
          return false;
        } else {
          // 新增未填写内容则删除
          this.$refs.tree.remove(Node);
        }
      } else {
        let { name, pId, id } = data;
        let params = {
          name,
          pId,
          id,
        };
        if (data.id != -999) {
          UpdateDepartment(params).then((res) => {
            if (res.data.state == 1) {
              this.editId = -1;
              this.$message.success("修改成功！");
            }
          });
          //   this.$nextTick(() => {
          //     this.$refs["slotTreeInput" + data.id].input.focus();
          //   });
        } else {
          // 新增部门
          AddDepartment(params).then((res) => {
            if (res.data.state == 1) {
              data.id = res.data.data;
              this.$set(data, "id", res.data.data);
              this.editId = -1;
              this.$message.success("新增成功！");
            }
          });
          //   this.$nextTick(() => {
          //     this.$refs["slotTreeInput" + data.id].input.focus();
          //   });
        }
      }
    },
    // 查询
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    // allowDrop(draggingNode, dropNode, type) {
    //   if (dropNode.data.name === "二级 3-1") {
    //     return type !== "inner";
    //   } else {
    //     return true;
    //   }
    // },
    // allowDrag(draggingNode) {
    //   return draggingNode.data.name.indexOf("三级 3-2-2") === -1;
    // },
    // 鼠标右击事件
    rightClick(event, object, Node, element) {
      this.currentData = object;
      this.currentNode = Node;
      if (Node.level === 1) {
        this.firstLevel = true;
      } else {
        this.firstLevel = false;
      }
      this.menuVisible = true;

      // let menu = document.querySelector('#card')
      // /* 菜单定位基于鼠标点击位置 */
      // menu.style.left = event.clientX + 'px'
      // menu.style.top = event.clientY + 'px'
      var main = document.getElementById("home");
      if (event.clientX > main.offsetWidth - 90) {
        var x = main.offsetWidth - 90;
      } else {
        var x = event.clientX;
      }
      if (event.clientY > main.offsetHeight - 90) {
        var y = main.offsetHeight - 90;
      } else {
        var y = event.clientY;
      }

      document.addEventListener("click", this.foo);
      //   this.$refs.card.style.left = x + "px";
      //   this.$refs.card.style.top = y + "px";
      this.style.left = x + "px";
      this.style.top = y + "px";
    },
    // 鼠标左击事件
    handleLeftclick(data, node) {
      this.foo();
    },
    //  取消鼠标监听事件 菜单栏
    foo() {
      this.menuVisible = false;
      //  要及时关掉监听，不关掉的是一个坑，不信你试试，虽然前台显示的时候没有啥毛病，加一个alert你就知道了
      document.removeEventListener("click", this.foo);
    },
    // 增加同级节点事件
    addSameLevelNode() {
      let id = Math.ceil(Math.random() * 100);
      var data = { id: id, label: "新增节点" };
      this.$refs.tree.append(data, this.currentNode.parent);
    },
    // 增加子级节点事件
    addChildNode() {
      // console.log(this.currentData);
      // console.log(this.currentNode);
      //   if (this.currentNode.level >= 3) {
      //     this.$message.error("最多只支持三级！");
      //     return false;
      //   }
      var data = { pId: this.currentData.id, id: -999, name: "", children: [] };
      this.$refs.tree.append(data, this.currentNode);
      // 获取编辑状态
      this.editId = -999;
      // 获取焦点
      this.$nextTick(() => {
        this.$refs["slotTreeInput" + -999].focus();
      });
    },
    // 删除节点
    deleteNode() {
      if (this.currentData.children&&this.currentData.children.length > 0) {
        this.$message.warning("当前部门含有子部门，不允许删除");
        return;
      } else {
        DeleDepartment(this.currentData.id).then((res) => {
          if (res.data.state == 1) {
            this.$message.success("删除成功");
            this.$refs.tree.remove(this.currentNode);
            // this.getAllDepartment()
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    // 编辑节点
    editNode(data) {
      this.currentData = data ? data : this.currentData;
      this.editId = data ? data.id : this.currentData.id;
      //   if (!this.currentData.isEdit) {
      //     this.$set(this.currentData, "isEdit", true);
      //   }
      // 获取焦点
      this.$nextTick(() => {
        this.$refs["slotTreeInput" + this.currentData.id].focus();
      });
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
			let arr,index
			let dragId = draggingNode.data.id
			if(dropType=='inner'){
				 arr = dropNode.childNodes
				 index = arr.findIndex(item=>item.data.id == dragId )
			}else{
				 arr = dropNode.parent.childNodes
				 index = arr.findIndex(item=>item.data.id == dragId )
			}
			if(index>-1){
				if(index==0){
					arr[index].data.num = 0.5
				}else{
					arr[index].data.num = arr[index-1].data.num + 0.5
				}
				let params = {
					id:dragId,
					pId:dropType=='inner'? dropNode.data.id : dropNode.data.pId,
					num:arr[index].data.num
				}
				UpdateDepartmentByMove(params).then(res=>{
					if(res.data.state==1){
						this.getAllDepartment()
					}else {
						this.$message.error(res.data.msg)
						this.getAllDepartment()
					}
				})
			}
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>
<style scoped lang="less">
/* 点击节点时的选中颜色 */
.tree-container /deep/.el-tree-node.is-current > .el-tree-node__content {
  color: blue !important;
}

.tree-container /deep/ .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.tree-container /deep/ .el-icon-caret-right:before {
  content: "\e791";
  font-size: 18px;
}

.tree-container /deep/ .el-tree-node__expand-icon {
  margin-left: 15px;
  padding: 0px;
}

.tree-container /deep/ .el-tree-node__expand-icon.is-leaf {
  margin-left: 0px;
}

.tree-container /deep/ .el-tree-node {
  position: relative;
  padding-left: 16px;
  // text-indent: 16px;
}

.tree-container /deep/ .el-tree-node__children {
  padding-left: 16px;
}

.tree-container /deep/ .el-tree > .el-tree-node:before {
  border-left: none;
}

.tree-container /deep/ .el-tree > .el-tree-node:after {
  border-top: none;
}
.tree-container /deep/ .el-tree > .el-tree-node:before {
  border-left: none;
}

.tree-container /deep/ .el-tree > .el-tree-node:after {
  border-top: none;
}

.tree-container /deep/ .el-tree-node:before {
  content: "";
  left: 10px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree-container /deep/ .el-tree-node:after {
  content: "";
  left: 10px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree-container /deep/ .el-tree-node:before {
  border-left: 1px dashed #ccc;
  bottom: 0px;
  height: 100%;
  top: -19px;
  width: 1px;
}

.tree-container /deep/ .el-tree-node:after {
  border-top: 1px dashed #ccc;
  height: 25px;
  top: 20px;
  width: 20px;
}

.el-tree-node :last-child:before {
  height: 40px;
}

.tree-container {
  margin: 10px;
}
.tree-container /deep/ .el-tree .el-tree-node {
  position: relative;
}
.tree-container /deep/ .el-tree-node .el-tree-node__content {
  height: 34px;
  padding-left: 0px !important;
  border: none;
}
.tree-container /deep/ .el-tree-node .el-tree-node__content::before {
  border-left: 1px dashed #ccc;
  height: 100%;
  top: 0;
  width: 1px;
  margin-left: 1px;
  margin-top: 0px;
  z-index: 8;
}
.tree-container
  /deep/
  .el-tree-node
  .el-tree-node__children
  .el-tree-node__content::before {
  border-left: 0px dashed #ccc;
  height: 100%;
  top: 0;
  width: 1px;
  margin-left: 1px;
  margin-top: 0px;
  z-index: 8;
}

.tree-container /deep/ .el-tree-node .el-tree-node__content::after {
  border-top: 1px dashed #ccc;
  height: 1px;
  top: 18px;
  width: 13px;
  margin-left: 1px;
  z-index: 8;
}

.tree-container
  /deep/
  .el-tree-node
  .el-tree-node__children
  .el-tree-node__content::after {
  border-top: 0px dashed #ccc;
}

.tree-container .el-tree-node .el-tree-node__content::before,
.tree-container .el-tree-node .el-tree-node__content::after {
  content: "";
  position: absolute;
  right: auto;
}
/deep/.el-table__placeholder {
  padding-left: 8px;
}
/deep/.el-card__body {
  padding: 10px !important;
  > div {
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
    &:hover {
      color: blue;
    }
  }
}
/*.lalala {*/
/*position: relative;*/
/*}*/
.text {
  font-size: 14px;
}
.el-tree {
  //   width: 20%;
  margin-top: 10px;
}
.search {
  //   width: 20%;
}

.item {
  padding: 18px 0;
}

.add {
  cursor: pointer;
  margin-top: 10px;
}

.delete {
  margin: 10px 0;
  cursor: pointer;
}

.edit {
  margin-bottom: 10px;
  cursor: pointer;
}

.search {
  cursor: pointer;
}

.box-card {
  width: 150px;
  position: fixed;
  z-index: 1000;
}
</style>
